<template>
  <b-card
    :id="`card-${file.id}`"
    :class="cardClass"
    border-variant="secondary"
    @dblclick.stop.prevent="openFolder"
    @contextmenu.stop.prevent="contextMenu"
  >
    <b-card-body
      class="p-0 m-0"
    >
      <div class="d-flex justify-content-between">
        <div @dblclick.stop.prevent="stopPropagation">
          <BFormCheckbox
            v-if="$can('update','object')"
            :checked="file.selected"
            @change="toggleSelected"
          />
        </div>
        <!--        <component-->
        <!--          :is="multipleOrSingleMenu(data.item.id)"-->
        <!--          ref="contextMenu"-->
        <!--          :file="file"-->
        <!--      />-->
        <ContextMenu
          ref="contextMenu"
          :selected-files="selectedFiles"
          :file="file"
          :staging="staging"
          :trashed="trashed"
          @loading="loading"
          @click.stop.prevent="contextMenu"
        />
      </div>
      <font-awesome-icon
        :icon="getIcon"
        class="fa-5x pt-1"
      />
      <hr>

      <div class="d-flex justify-content-between align-items-center">
        <h6
          style="right: 50px"
          class="m-0"
          :title="file.label"
        >
          {{ file.label + (file.is_folder ? '' : ' - v.' + file.latest_version_name) | truncate(15,'...') }}
        </h6>
        <div class="p-0" />
      </div>
      <div
        v-if="showExpiration"
        class="mt-50 text-center"
      >
        <ExpirationBadge :expiration-date="file.expiration_date" />
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import useMyStore from '@/services/useMyStore'
import ContextMenu from '@/layouts/components/FileContextMenu.vue'
import ExpirationBadge from '@/layouts/components/ExpirationBadge.vue'
import * as expirationHelpers from '@/helpers/expiration-helpers'
import { BCard, BCardBody, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'FileCard',
  components: {
    ContextMenu,
    ExpirationBadge,
    BCard,
    BCardBody,
    BFormCheckbox,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    selectedFiles: {
      type: Array,
      default: () => [],
    },
    staging: {
      type: Boolean,
      default: () => false,
    },
    trashed: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const { currentFolder } = useMyStore()

    return { currentFolder }
  },
  computed: {
    getIcon() {
      if (this.file.is_folder) {
        return 'folder'
      }

      let icon = 'file'
      switch (this.file.file_types) {
        case 'pdf':
          icon = 'file-pdf'
          break
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'git':
          icon = 'image'
          break
        case 'txt':
          icon = 'file-lines'
          break
        case 'doc':
        case 'docx':
          icon = 'file-word'
          break
        case 'xls':
        case 'xlsx':
          icon = 'file-excel'
          break
        case 'csv':
          icon = 'file-csv'
          break
        case 'flv':
        case 'webm':
        case 'mkv':
        case 'avi':
        case 'wmv':
        case 'mp4':
          icon = 'file-video'
          break
        case 'aac':
        case 'mp3':
        case '3gp':
        case 'aa':
        case 'm4a':
        case 'wma':
        case 'ogg':
          icon = 'file-audio'
          break
        case 'xml':
          icon = 'file-code'
          break
        case 'zip':
          icon = 'file-zipper'
          break
        default:
          break
      }
      return icon
    },
    label() {
      return this.file.label
    },
    selected() {
      return this.file.selected
    },
    cardClass() {
      return {
        selected: this.selected,
      }
    },
    showExpiration() {
      return Boolean(this.file.is_folder)
        && !this.trashed
        && !this.staging
        && expirationHelpers.normalizeDate(this.file.expiration_date) !== null
    },
  },
  methods: {
    toggleSelected() {
      this.$emit('select', this.file)
    },
    contextMenu() {
      const menu = this.$refs.contextMenu
      menu.open(this.file)
    },
    openFolder() {
      if (this.file.is_folder === 1) {
        this.$emit('open-folder', this.file)
      }
    },
    stopPropagation(e) {
      e.stopPropagation()
    },
    loading(show) {
      this.$emit('loading', show)
    },
  },
}
</script>

<style scoped>
.selected {
  border-color: #f5f5f5;
}

</style>
